/* Kratus — registro global de GSAP/ScrollTrigger para las secciones custom.
   Un solo lugar donde se registra el plugin y se expone un helper de arranque
   que funciona tanto en la carga normal como en el theme editor (Shopify
   dispara `shopify:section:load` cada vez que Tony reordena/edita una seccion). */

(function () {
  if (typeof window.gsap === 'undefined') return;

  if (typeof window.ScrollTrigger !== 'undefined') {
    window.gsap.registerPlugin(window.ScrollTrigger);
  }

  window.KratusMotion = {
    mm: window.gsap.matchMedia(),

    /**
     * Corre `init(root)` cuando el DOM esta listo y de nuevo cada vez que
     * Shopify vuelve a montar la seccion `sectionId` en el editor de temas.
     */
    ready: function (sectionId, init) {
      function run(root) {
        try {
          init(root || document);
        } catch (err) {
          if (window.Shopify && window.Shopify.designMode) {
            console.error('[Kratus motion] ' + sectionId, err);
          }
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          run(document);
        });
      } else {
        run(document);
      }

      document.addEventListener('shopify:section:load', function (event) {
        if (event.detail && event.detail.sectionId === sectionId) {
          run(event.target);
        }
      });
    },
  };
})();

/* Eclipse header — estado transparente↔sólido según scroll (independiente del sticky nativo de Dawn). */
(function () {
  if (typeof window.KratusMotion === 'undefined') return;
  window.KratusMotion.ready('header', function (root) {
    var header = (root || document).querySelector('.header--eclipse');
    if (!header || header.dataset.eclipseBound) return; // guard: bind once (evita listeners apilados en shopify:section:load)
    header.dataset.eclipseBound = '1';
    // Umbral: cuando el hero deja de cubrir el header. Fallback = alto del header.
    // [E4.1] .collection-hero--eclipse sumado a la lista: mismo hero full-bleed oscuro,
    // ahora también en la página de colección — sin esto, el fallback fijo de 80px hacía
    // que el header pasara a sólido casi de inmediato en vez de escalar con el alto real.
    function threshold() {
      var hero = document.querySelector('.hero-eclipse, .collection-hero--eclipse, .section-header + * .banner, [id^="Slider-"], .slideshow');
      return hero ? Math.max(hero.offsetHeight * 0.6, 80) : 80;
    }
    var t = threshold();
    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      header.classList.toggle('header--eclipse-solid', y > t);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { t = threshold(); onScroll(); }, { passive: true });
    onScroll();

    // [E1.5 Parte A] Clase de estado "mega abierto" — reemplaza el intento previo de resolver
    // el color del nav/logo con `:has(.mega-menu[open])` en CSS (no ganaba la cascada contra la
    // inversión a blanco de [E3.1] combinado con `:not(.header--eclipse-solid)`). En vez de seguir
    // escalando especificidad con selectores relacionales, el JS marca el estado explícito aquí:
    // `header--menu-open` en el <header--eclipse> cuando CUALQUIER <details class="mega-menu">
    // del header está abierto. El CSS solo lee la clase (ver section-header-eclipse.css [E1.5 Parte A]).
    var megaMenus = header.querySelectorAll('details.mega-menu');
    function syncMenuOpenState() {
      var anyOpen = false;
      for (var i = 0; i < megaMenus.length; i++) {
        if (megaMenus[i].hasAttribute('open')) {
          anyOpen = true;
          break;
        }
      }
      header.classList.toggle('header--menu-open', anyOpen);
    }
    for (var j = 0; j < megaMenus.length; j++) {
      // Evento nativo de <details>: dispara en cada apertura/cierre, sin importar si el usuario
      // usa mouse, teclado o toca otro summary (Dawn cierra los demás <details> por su cuenta).
      megaMenus[j].addEventListener('toggle', syncMenuOpenState);
    }
    syncMenuOpenState(); // sincroniza al bind, por si algun mega ya viene abierto en el editor de temas

    // [Fix movil 2026-07-27] Clase de estado "drawer movil abierto".
    // Diagnostico in-vivo (home, iPhone 390px): en paginas con hero el header es `absolute` y
    // TRANSPARENTE (regla [E3.1] de section-header-eclipse.css). El drawer de la hamburguesa de
    // Dawn es `absolute; top:100%` colgado de ese header, asi que heredaba los dos sintomas que
    // reporto Tony: (a) el encabezado del menu dejaba ver la foto del hero detras y (b) el
    // marquee promo, que va en flujo, quedaba cortado arriba en cuanto la pagina tenia algo de
    // scroll. El estado `header--menu-open` de arriba NO cubre este caso: solo escucha los
    // <details class="mega-menu"> del desktop. Se marca aparte (no se reusa la misma clase) para
    // que el drawer NO herede el logo en negro del mega — en movil el logo se queda amarillo,
    // igual que al abrir el menu en coleccion. El CSS solo lee esta clase.
    var mobileDrawer = header.querySelector('details.menu-drawer-container');
    if (mobileDrawer) {
      var syncDrawerOpenState = function () {
        var isOpen = mobileDrawer.hasAttribute('open');
        header.classList.toggle('header--drawer-open', isOpen);
        if (!isOpen) return;
        // Con la clase puesta, el CSS ya movio el header a `fixed; top:0` — su borde inferior real
        // deja de coincidir con el `--header-bottom-position` que Dawn calculo para la posicion
        // anterior (medido: Dawn decia 99px, el borde real era 74px → el drawer quedaba 25px corto
        // y asomaba la pagina por debajo). Se expone el alto real del header para que el drawer
        // llegue exacto al fondo del viewport (ver section-header-eclipse.css). Se lee DESPUES del
        // toggle a proposito: getBoundingClientRect fuerza el recalculo con la clase ya aplicada.
        var section = header.closest('.section-header') || header;
        document.documentElement.style.setProperty(
          '--kratus-header-h',
          Math.round(section.getBoundingClientRect().height) + 'px'
        );
      };
      mobileDrawer.addEventListener('toggle', syncDrawerOpenState);
      syncDrawerOpenState();
    }

    // [E1.6 FIX5] Apertura por hover en desktop (mouse fino). El <details> nativo de Dawn solo
    // abre por click; Eclipse (frame-101) abre al pasar el cursor sobre el nav-item. Gateado a
    // hover+pointer fino para no interceptar touch/trackpad-sin-hover, que conserva el click
    // nativo del propio <details>. No se hace preventDefault en ningun lado: click y teclado
    // (Enter/Space/Escape via foco nativo del <details>) siguen intactos; el listener `toggle`
    // de arriba sincroniza `.header--menu-open` igual, sin importar si el open lo puso el mouse
    // o el hover-intent de aqui.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      for (var k = 0; k < megaMenus.length; k++) {
        (function (details) {
          var wrapper = details.closest('header-menu');
          if (!wrapper) return; // sin wrapper header-menu, no hay donde bindear enter/leave sin cortar el panel
          wrapper.addEventListener('pointerenter', function () {
            // Cancela el cierre diferido (si el cursor volvio a entrar antes de que corriera).
            if (details._eclipseCloseTimer) {
              clearTimeout(details._eclipseCloseTimer);
              details._eclipseCloseTimer = null;
            }
            // Cierra cualquier otro mega abierto antes de abrir este (mutuamente excluyentes).
            for (var m = 0; m < megaMenus.length; m++) {
              if (megaMenus[m] !== details) megaMenus[m].open = false;
            }
            details.open = true;
          });
          wrapper.addEventListener('pointerleave', function () {
            // Cierre diferido ~150ms: da margen a mover el cursor del summary hacia el panel
            // (el listener esta en el <header-menu> completo, que envuelve summary+panel, asi
            // que normalmente ni siquiera dispara pointerleave al cruzar entre ambos).
            details._eclipseCloseTimer = setTimeout(function () {
              details.open = false;
              details._eclipseCloseTimer = null;
            }, 150);
          });
        })(megaMenus[k]);
      }
    }
  });
})();

/* Eclipse hero — [E3.1] marca la página cuando el hero full-bleed es la primera sección
   y expone el alto del marquee promo como --kratus-chrome-top, para que el header flote
   como overlay JUSTO bajo el marquee (no encima) y el hero llene el viewport restante
   (ver section-header-eclipse.css y section-hero-eclipse.css).
   [E4.1] Mismo marcador reutilizado por el hero de la página de colección
   (.collection-hero--eclipse, sections/main-collection-banner.liquid): también es un
   full-bleed oscuro bajo el nav, así que el nav debe verse blanco encima igual que en el
   home — se agrega al selector en vez de duplicar la lógica de acoplamiento. */
(function () {
  if (typeof window.KratusMotion === 'undefined') return;
  window.KratusMotion.ready('hero-eclipse', function (root) {
    if (!(root || document).querySelector('.hero-eclipse, .collection-hero--eclipse')) return;
    document.documentElement.classList.add('page-has-hero-eclipse');
    // Alto del marquee promo medido en vivo (sin hardcode): offset del header overlay.
    function setChromeTop() {
      var marquee = document.querySelector('.section-promo-marquee');
      var h = marquee ? Math.round(marquee.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--kratus-chrome-top', h + 'px');
    }
    setChromeTop();
    if (!document.documentElement.dataset.kratusChromeBound) { // bind once (evita listeners apilados en shopify:section:load)
      document.documentElement.dataset.kratusChromeBound = '1';
      window.addEventListener('resize', setChromeTop, { passive: true });
    }
  });
})();
